// var myDropzone = new Dropzone("div#imgupload", { url: "/upload.php"});
// var myModal = document.getElementById('imgmodal')
// var myModal = new bootstrap.Modal(document.getElementById('imgmodal'), {})

// myDropzone.on("addedfile", function (file) {
//     console.log("A file has been added", file);
//     // document.querySelector('.imgcontainer').style.backgroundImage = "url('uploads/"+file.name+"')";
//     document.getElementById('imgedit').setAttribute('src', '/uploads/' + file.name);
//     myModal.show();
// });

// var myDropzone = Dropzone.options.myFileUpload = { // camelized version of the `id`
//     paramName: "file", // The name that will be used to transfer the file
//     maxFilesize: 4, // MB
//     // accept: function(file, done) {
//     //     if (file.name == "justinbieber.jpg") {
//     //         done("Naha, you don't.");
//     //     }
//     //     else { done(); }
//     // }
//     addedfile: function (file) {
//         document.getElementById('imgedit').setAttribute('src', '/uploads/' + file.name);
//         // myModal.show();
//     }
// };

// myDropzone.on("addedfile", function (file) {
//     console.log("A file has been added", file);
//     // document.querySelector('.imgcontainer').style.backgroundImage = "url('uploads/"+file.name+"')";
//     document.getElementById('imgedit').setAttribute('src', '/uploads/' + file.name);
//     myModal.show();
// });